import React from "react";
import { useTranslation } from "react-i18next";
import "./services.css";
import { FcCheckmark } from "react-icons/fc";

const Services = () => {
  const { t } = useTranslation();

  return (
    <section id="services">
      <h4>{t("services.subtitle")}</h4>
      <h2>{t("services.title")}</h2>
      <div className="container services__container">
        <article className="service">
          <div className="service__head">
            <h3>{t("services.cards.Development.title")}</h3>
          </div>
          <ul className="service__list">
            <li>
              <FcCheckmark className="service__list-icon" />
              <p>{t("services.cards.Development.list1")}</p>
            </li>
            <li>
              <FcCheckmark className="service__list-icon" />
              <p>{t("services.cards.Development.list2")}</p>
            </li>
            <li>
              <FcCheckmark className="service__list-icon" />
              <p>{t("services.cards.Development.list3")}</p>
            </li>
            <li>
              <FcCheckmark className="service__list-icon" />
              <p>{t("services.cards.Development.list4")}</p>
            </li>
            <li>
              <FcCheckmark className="service__list-icon" />
              <p>{t("services.cards.Development.list5")}</p>
            </li>
            <li>
              <FcCheckmark className="service__list-icon" />
              <p>{t("services.cards.Development.list6")}</p>
            </li>
          </ul>
        </article>
        {/* END SOFTWARE DEVELOPMENT */}
        <article className="service">
          <div className="service__head">
            <h3>{t("services.cards.Technical.title")}</h3>
          </div>
          <ul className="service__list">
            <li>
              <FcCheckmark className="service__list-icon" />
              <p>{t("services.cards.Technical.list1")}</p>
            </li>
            <li>
              <FcCheckmark className="service__list-icon" />
              <p>{t("services.cards.Technical.list2")}</p>
            </li>
            <li>
              <FcCheckmark className="service__list-icon" />
              <p>{t("services.cards.Technical.list3")}</p>
            </li>
            <li>
              <FcCheckmark className="service__list-icon" />
              <p>{t("services.cards.Technical.list4")}</p>
            </li>
            <li>
              <FcCheckmark className="service__list-icon" />
              <p>{t("services.cards.Technical.list5")}</p>
            </li>
          </ul>
        </article>
        {/* END TECHNICAL SUPPORT*/}
        <article className="service">
          <div className="service__head">
            <h3>{t("services.cards.Design.title")}</h3>
          </div>
          <ul className="service__list">
            <li>
              <FcCheckmark className="service__list-icon" />
              <p>{t("services.cards.Design.list1")}</p>
            </li>
            <li>
              <FcCheckmark className="service__list-icon" />
              <p>{t("services.cards.Design.list2")}</p>
            </li>
            <li>
              <FcCheckmark className="service__list-icon" />
              <p>{t("services.cards.Design.list3")}</p>
            </li>
            <li>
              <FcCheckmark className="service__list-icon" />
              <p>{t("services.cards.Design.list4")}</p>
            </li>
            <li>
              <FcCheckmark className="service__list-icon" />
              <p>{t("services.cards.Design.list5")}</p>
            </li>
          </ul>
        </article>
        {/* END Graphic Design and Digital Marketing */}
      </div>
    </section>
  );
};

export default Services;
